import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  Batch,
  Team,
  User,
  Campus,
  CLUSTERS,
  CAMPUSES,
  ROLES,
 } from '../../../shared';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.css']
})
export class UserCardComponent {
  @Input() user: User;
  @Input() team: Team;
  @Input() batch: Batch;
  @Input() campus: Campus;
  @Input() currentClusterName: string;
  clusters;
  @Output() switchCluster: EventEmitter<string> = new EventEmitter();

  constructor() { 
    this.clusters = CLUSTERS;
  }

  onSwitchCluster() {
    if (this.campus.location === CAMPUSES.VA) {
      let updatedClusterName = this.currentClusterName === CLUSTERS.VA.DARK ? CLUSTERS.VA.LIGHT : CLUSTERS.VA.DARK;
      this.switchCluster.emit(updatedClusterName);
    }
  }

  isOnDarkSide(): boolean {
    if (this.campus && this.campus.location === CAMPUSES.VA) {
      if (this.user && this.user.role === ROLES.TEACHER) return true;
      return this.batch && this.batch.isGraduated;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/me/components/user-card/user-card.component.ts